module.exports = "/assets/46ac6d9d692ffd74610730e17a770070.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/UL.png
// module id = 1895
// module chunks = 0